import React from 'react';
import PropTypes from 'prop-types';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { autobind } from 'core-decorators';

@autobind
class Pager extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      Current: this.props.activePage ? this.props.activePage : 1,
      Pages: this.getItems(1),
      automaticPage: true,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.activePage !== this.props.activePage) {
      if (newProps.ehApresentacao) {
        if (this.state.automaticPage)
          if (newProps.activePage > this.props.activePage) {
            this.nextClicked(false);
          } else {
            this.prevClicked(false);
          }
        else {
          this.setState({ automaticPage: true });
        }
      } else {
        this.setState({ Current: newProps.activePage });
      }
    }

    if (newProps.totalPages !== this.props.totalPages) {
      this.setState({
        Pages: this.getItems(1, newProps.totalPages, newProps.totalDisplayed),
      });
    }
  }

  handleUpdatePages() {
    setTimeout(() => {
      this.setState(
        {
          Current: this.props.activePage,
          Pages: this.getItems(1),
        },
        () => {}
      );
    }, 200);
  }

  getItems(startPage, totalPagesParameter, totalDisplayedParameter) {
    let items = [];

    const totalPagesFinal = totalPagesParameter ?? this.props.totalPages;
    const totalDisplayedFinal =
      totalDisplayedParameter ?? this.props.totalDisplayed;

    var maxItems = Math.min(totalPagesFinal, totalDisplayedFinal);
    for (var i = startPage; i <= maxItems + startPage - 1; i++) {
      items[i] = i;
    }
    return items;
  }

  pageClicked(e) {
    e.preventDefault();

    this.setState({ automaticPage: false });

    let pageNumber = parseInt(e.target.getAttribute('href'), 10);
    //only change page if user clicks on a different one than what is current
    if (pageNumber !== this.state.Current) {
      this.changePage(pageNumber);
    }
  }

  changePage(pageNumber) {
    const items = this.getPagesToShow(pageNumber);
    if (items) {
      this.setState({ Current: pageNumber, Pages: items }, () => {
        this.props.pageChanged(this.state.Current);
      });
    } else {
      this.setState({ Current: pageNumber }, () => {
        this.props.pageChanged(this.state.Current);
      });
    }
  }

  getPagesToShow(pageNumber) {
    const { totalDisplayed, totalPages } = this.props;
    const windowSize = Math.min(totalDisplayed, totalPages);
    const half = Math.floor(windowSize / 2);
    let start = pageNumber - half;
    const maxStart = Math.max(1, totalPages - windowSize + 1);
    if (start < 1) start = 1;
    if (start > maxStart) start = maxStart;

    const items = this.getItems(start, windowSize);
    return items;
  }

  nextClicked(stopAutomatic = false) {
    //e != null && e.preventDefault();

    if (stopAutomatic) this.setState({ automaticPage: false });

    const nextPage = this.state.Current + 1;
    this.changePage(nextPage);
  }

  prevClicked(stopAutomatic = false) {
    //e != null && e.preventDefault();

    if (stopAutomatic) this.setState({ automaticPage: false });

    const nextPage = this.state.Current - 1;

    this.changePage(nextPage);
  }

  render() {
    return (
      <Pagination {...this.props.other}>
        <PaginationItem disabled={this.state.Current === 1}>
          <PaginationLink
            className={this.state.Current === 1 ? 'bg-light-gray' : ''}
            previous
            onClick={this.prevClicked.bind(true)}
          />
        </PaginationItem>

        {this.state.Pages.map((p) => {
          return (
            <PaginationItem key={p} active={p === this.state.Current}>
              <PaginationLink onClick={this.pageClicked} href={p}>
                {p}
              </PaginationLink>
            </PaginationItem>
          );
        })}
        <PaginationItem disabled={this.state.Current === this.props.totalPages}>
          <PaginationLink
            className={
              this.state.Current === this.props.totalPages
                ? 'bg-light-gray'
                : ''
            }
            next
            onClick={this.nextClicked.bind(true)}
          />
        </PaginationItem>
      </Pagination>
    );
  }
}

Pager.propTypes = {
  //fired when user clicks a page number
  pageChanged: PropTypes.func.isRequired,
  //the total number of pages
  totalPages: function (props) {
    if (!props.totalPages) {
      return new Error('totalPages is required');
    } else if (props.totalPages < props.totalDisplayed) {
      return new Error('totalpages must be >= totalDisplayed');
    } else if (props.totalPages < 2) {
      return new Error('totalPages must be 2 or greater');
    }
  },
  //the total number of pages displayed
  totalDisplayed: PropTypes.number,
};

Pager.defaultProps = {
  totalDisplayed: 5,
};
export default Pager;
